<template>
  <div v-show="posts.length" class="row q-col-gutter-lg">
    <div
      v-for="post in posts"
      :key="post.id"
      class="col-xs-12 col-sm-6 col-md-4 col-lg-3"
    >
      <slot v-bind="post"></slot>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { Post } from '@/type';

export default defineComponent({
  props: {
    posts: {
      type: Array as () => Post[],
      default() {
        return [];
      },
    },
  },
});
</script>
